"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCellDrillable = void 0;
// (C) 2021 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var colDrillHeadersFactory_1 = require("./colDrillHeadersFactory");
function isCellDrillable(colDescriptor, row, dv, drillablePredicates) {
    if (drillablePredicates.length === 0) {
        return false;
    }
    var headers = colDrillHeadersFactory_1.createDrillHeaders(colDescriptor, row);
    return headers.some(function (drillItem) {
        return sdk_ui_1.isSomeHeaderPredicateMatched(drillablePredicates, drillItem, dv);
    });
}
exports.isCellDrillable = isCellDrillable;
//# sourceMappingURL=cellDrillabilityPredicate.js.map